import * as actionTypes from "../constants/typeConstants";

export const getTypesReducer = (state = { types: [] }, action) => {
    switch (action.type) {
        case actionTypes.GET_TYPES_REQUEST:
           return {
               ...state,
               types: action.payload,
           }
        case actionTypes.SAVE_ATTR:
            return {
                ...state,
                types: action.payload,
            }
        case actionTypes.INSERT_TYPE:
            return {
                ...state,
                types: action.payload,
            }
        case actionTypes.DELETE_TYPE:
            return {
               ...state,
               types: action.payload,
            }
        default:
            return state;
    }
}